import { routeTexts, headerMenuTexts, headerTexts } from '@/assets/strings';
import HandshakeLogo from '@/assets/icons/handshake.svg';
import DialogLogo from '@/assets/icons/dialog.svg';
import AcademyLogo from '@/assets/icons/academy.svg';
import Categories from '@/assets/icons/categories.svg';
import Document from '@/assets/icons/agreementKVKK.svg';

export type Route = {
  path: string;
  label: string;
  blank: boolean;
  event: any;
  icon?: any;
};

export const headerRoutes: Route[] = [
  {
    path: routeTexts.campaignRequests,
    label: headerTexts.myRequests,
    blank: false,
    event: {
      buttonType: 'forward',
      itemName: headerTexts.myRequests,
      location: 'Header',
    },
    icon: HandshakeLogo,
  },
];

export const headerMenuRoutesDesktop: Route[] = [
  {
    path: routeTexts.academy,
    label: headerMenuTexts.academy,
    blank: true,
    event: {
      buttonType: 'forward',
      itemName: headerMenuTexts.academy,
      location: 'Header',
    },
    icon: AcademyLogo,
  },
  {
    path: routeTexts.help,
    label: headerMenuTexts.help,
    blank: true,
    event: {
      buttonType: 'forward',
      itemName: headerMenuTexts.help,
      location: 'Header',
    },
    icon: DialogLogo,
  },
  {
    path: routeTexts.gdpr,
    label: headerMenuTexts.gdpr,
    blank: true,
    event: {
      buttonType: 'forward',
      itemName: headerMenuTexts.gdpr,
      location: 'Header',
    },
    icon: Document,
  },
];

export const headerMenuRoutesMobile: Route[] = [
  {
    path: routeTexts.campaigns,
    label: headerMenuTexts.campaigns,
    blank: false,
    event: {
      buttonType: 'forward',
      itemName: headerMenuTexts.campaigns,
      location: 'Header',
    },
    icon: Categories,
  },
  ...headerRoutes,
  ...headerMenuRoutesDesktop,
];
